export default "Base header popover template";